export const API_KEY = "61074439a5e3fc647d50d6c96f00c3a0"
export const baseURL = "https://api.themoviedb.org/3/"
export const imageURL = 'https://image.tmdb.org/t/p/original'